// This is a test channel.
import consumer from './cable';

window.App = window.App || {};
$(document).ready(() => {
  if (!$('#ActionCableChecker').length) { return; }

  App.cable_checker = consumer.subscriptions.create('PingChannel', {
    received(data) {
      console.log(`Action Cable is working. Someone clicked on input ${data['selected']}`);
    },
    connected() {
      console.log('Action Cable Ping Channel is connected');
      $('.check-cable').click(function(event) {
        App.cable_checker.ping(event.target.value);
      })
    },
    ping(selected) {
      this.perform('ping', {selected: selected})
    }
  })
});
